module.exports = __webpack_public_path__ + "media/images/home/logo_fundag-166bc522f4ca76eb728a268ff1854a53.png";